type GeniusMissedExamInput = {
  examStatus: string;
  endTime?: string;
  studentStartTime?: string;
};

const ATTEMPTED_STATUSES = new Set([
  "attempted",
  "markscalculated",
  "submitted",
]);

const ACTIVE_STATUSES = new Set(["in_progress", "started"]);

/** True when the deeplink exam is missed (explicit status or window ended without attempt). */
export function isGeniusMissedExam(context: GeniusMissedExamInput): boolean {
  const status = context.examStatus.trim().toLowerCase();
  if (status === "missed") return true;
  if (ATTEMPTED_STATUSES.has(status) || ACTIVE_STATUSES.has(status)) {
    return false;
  }
  if (context.studentStartTime) return false;

  const endMs = context.endTime
    ? new Date(context.endTime).getTime()
    : Number.NaN;
  return !Number.isNaN(endMs) && endMs <= Date.now();
}
